// ** React Import
import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';
// ** Reactstrap Import
import { Card, Row, Col, Button, Spinner } from 'reactstrap';
// ** Utils
import { getUserData, renderClient } from '../../../../utility/Utils';
// ** Image Import
import bg from '@src/assets/images/banner/default.png';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { socialIconsMapper } from '../../constants';
import { followAction, getProfileAction, unFollowAction } from '../../store/action';

const Introduction = ({ contactId: memberContactId, responsiveItems }) => {
  const location = JSON.parse(localStorage.getItem('location'));
  const contactId = location && location.contactId;
  const userData = getUserData();
  const pathName = useLocation()?.pathname;
  const history = useHistory();
  const loca = useLocation();
  const params = queryString.parse(loca.search);
  const [isUnFollowLoading, setIsUnFollowLoading] = useState(false);
  const [isFollowLoading, setIsFollowLoading] = useState(false);

  const { profile, community } = useSelector((state) => state?.socialCommunity);
  console.log('Profile', profile);
  const dispatch = useDispatch();
  // console.log("Path", pathName === "/community/profile");
  useEffect(() => {
    if (memberContactId)
      dispatch(getProfileAction(pathName === '/community/profile' ? contactId : memberContactId));
  }, [contactId, memberContactId]);
  const handleMessage = () => {
    history.push('/community/message', { from: pathName });
  };

  const handleFollow = (contactId, memberContactId) => {
    setIsFollowLoading(true);
    dispatch(
      followAction({
        organizationId: location.organizationId,
        userId: location.assignerId,
        communityId: community?._id,
        followId: contactId,
        followingId: memberContactId
      })
    ).then(async (res) => {
      dispatch(getProfileAction(contactId));
      setIsFollowLoading(false);
    });
  };

  const handleUnfollow = (contactId, memberContactId) => {
    setIsUnFollowLoading(true);
    dispatch(unFollowAction(contactId, memberContactId)).then(async (res) => {
      dispatch(getProfileAction(contactId));
      setIsUnFollowLoading(false);
    });
  };

  const isFollowing =
    profile?.followersList?.length &&
    profile?.followersList?.find((follower) =>
      follower?.followId?.includes(contactId || memberContactId)
    );

  return (
    <>
      <Card className="mb-50 ">
        <div
          style={{
            backgroundColor: ' #212226',
            display: 'flex',
            backgroundRepeat: 'round',
            height: '12rem',
            backgroundImage: `url("${profile?.coverPhoto ? profile?.coverPhoto : bg}")`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div
            className="position-relative d-flex flex-column align-items-center"
            style={{
              zIndex: '2',
              left: '4rem',
              bottom: '-4rem',
              width: '8rem',
              height: '8rem'
            }}
          >
            {/* <span
              className="position-absolute rounded-circle border border-white"
              style={{
                //backgroundColor: data?.activityStatus ? '#28c76f' : '#ea5455',
                height: '1.5rem',
                width: '1.5rem',
                zIndex: '10',
                top: '0.5rem',
                left: '6rem'
              }}
            /> */}
            {renderClient({
              ...profile,
              size: 'xxl'
            })}
          </div>
        </div>

        <Row className="d-flex flex-column flex-md-row justify-content-md-between align-content-md-center mt-5 mb-1 mx-0">
          <Col className="d-flex flex-column">
            {/* Name  */}
            <div className="flex-row text-start">
              <div className="h2">
                <strong>
                  {pathName === '/community/profile'
                    ? userData?.fullName
                    : profile?.fullName ?? 'N/A'}
                </strong>
              </div>
              {/* <span className="p-1 pt-0">
                @{profile?.fullName?.split(' ')?.[0]?.toLowerCase()} {'• Joined '}
                {moment(profile?.createdAt).format('MM/DD/yyyy')}
              </span> */}
            </div>
            {/* Connections */}
            <div style={{ marginBottom: '7px' }} className="text-start d-xxl-flex d-xl-flex">
              <b>{profile?.followersList?.length || 0}</b>&nbsp;followers&nbsp;•&nbsp;
              <b>{profile?.followingList?.length || 0}</b>&nbsp;following
            </div>
            {/* Bio */}
            {profile?.quickIntro?.length ? <p>{profile?.quickIntro}</p> : null}
            {/*  Render those Icons how have value at link */}
            <div className="d-flex align-items-center gap-1">
              {profile?.socialLinks
                ?.filter((link) => link?.link && link?.link?.trim() !== '')
                .map((link, index) => {
                  const IconComponent = socialIconsMapper[link.name]?.icon;
                  // const encodedLink = encodeURIComponent(link?.link?.trim());
                  // const url = encodedLink !== '' ? encodedLink :  || '#';
                  return (
                    <a
                      key={index}
                      href={socialIconsMapper[link?.name]?.defaultUrl + link?.link}
                      target="_blank"
                      title={link?.name}
                    >
                      {IconComponent}
                    </a>
                  );
                })}
            </div>
          </Col>
          {params?.contactId !== (contactId || memberContactId) &&
  !responsiveItems?.some((item) => pathName === item.path) && (
    <Col className="d-flex justify-content-between align-items-center align-items-md-end gap-1 mt-1">
      <Button
        onClick={() =>
          isFollowing
            ? handleUnfollow(contactId, memberContactId)
            : handleFollow(contactId, memberContactId)
        }
        color="light"
        style={{
          backgroundColor: '#E4E6EB',
          border: '1px solid #E4E6EB',
          fontSize: '1rem',
          lineHeight: '26px',
          padding: '4px 22px',
          textTransform: 'capitalize'
        }}
        className="text-center m-0 cursor-pointer rounded w-100"
      >
        <span className="fw-bolder align-middle ms-25">
          {isFollowLoading || isUnFollowLoading ? (
            <Spinner size="sm" color="primary" />
          ) : isFollowing ? (
            'Unfollow'
          ) : (
            'Follow'
          )}
        </span>
      </Button>
      <Button onClick={handleMessage} color="primary" className="w-100">
        Message
      </Button>
    </Col>
  )}
        </Row>
      </Card>
    </>
  );
};

export default Introduction;
